module.exports = __webpack_public_path__ + "img/login.c69c1d57.png";